import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IVerifyOTPPayload,
  IVerifyOTPResponse,
} from "models/setting/verifyOTP";
import { verifyOTP } from "services/setting";
import { handleSuccessAction, handleErrorAction } from "./verifyOTPActions";

function* verifyOTPSaga({ payload }: { payload: IVerifyOTPPayload }) {
  try {
    const response: IVerifyOTPResponse = yield call(verifyOTP, payload);
    yield put(handleSuccessAction(response));
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onVerifyOTPWatcher() {
  yield takeLatest(ActionType.VERIFY_OTP as any, verifyOTPSaga);
}

export default [fork(onVerifyOTPWatcher)];
